import {
  Component,
  AfterContentInit,
  OnDestroy,
  Input,
  OnInit,
  Optional,
  ViewContainerRef,
  ViewChild,
} from '@angular/core';
import { PlycaDataService } from '../../../services/plyca.service';
import { Router } from '@angular/router';
import {
  TaskDTO,
  getSimpleIdentifierFromString,
  DivisionDTO,
  Link,
  ActionTypeDTO,
  ActionDTO,
  ElementsVisibilityState,
  ElementVisibilityStateDTO,
  ProcedureDTO,
  getSimpleIdentifier,
  DocumentDTO,
  UserDTO,
} from '../../api/plyca-dtos';
import { UserService } from '../../user.service';
import { UIService, generateRandomIdentifier } from '../../ui.service';
import {
  RuleDTO,
  RuleSeverities,
  RuleOpeningModeTypeDTO,
  RuleTypes,
  RuleWorkStates,
  RuleStates,
  RuleParameters,
} from '../../api/plyca-dtos-v2';
import {
  forkJoin,
  throwError,
  Observable,
  of,
  interval,
  timer,
  concat,
} from 'rxjs';
import { Configuration } from '../../conf/app.constants';
import { TaskService } from '../../tasks/task.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../store/AppState';
import { RuleService } from '../rules/RuleService';
import { DossierService } from '../dossier.service';
import {
  HelpService,
  HelpType,
} from '../../components/common/help/help.service';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';
import {
  tap,
  finalize,
  catchError,
  take,
  switchMap,
  concatMap,
} from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { UserPrefs, TasksViewPrefs } from '../../api/UserPrefs-dto';
import { ProfileService } from '../../../services/profile.services';
import { SET_ELEMVISIBILITY } from '../../store/elemVisibilityState';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import {
  DialogService,
  DynamicDialogRef,
  DynamicDialogConfig,
} from 'primeng-lts/dynamicdialog';
import { multiSignatureComponent } from '../../tasks/multiSignature/multiSignature.component';
import { AppConfiguration } from '../../conf/app.configuration';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { AuditComponent } from '../audit/audit.component';
import { documentViewerComponent } from '../../documents/documentViewer/documentViewer.component';
import { FieldConfig } from '../../api/contract-notice-dto';
import { MenuItem } from 'primeng-lts/api';
import { HttpClient } from '@angular/common/http';
import { UserPrefsService } from '../../store/user-prefs.service';
import { MANUALPROCESSINGMODE_ID } from '../procedures/procedureCircuit.component';
import { ActionsProcessComponent } from '../../actions/actions.process.component';
import { style } from '@angular/animations';
import { InboxUsersComponent } from '../audit/inboxusers.component';

const ACTION_DIVISION_GROUP = 'ACTION_DIVISION_GROUP';

@Component({
  selector: 'dossierActionsList',
  templateUrl: 'dossierActionsList.template.html',
  // ,styleUrls: ['./dossierActionsList.component.css']
  styles: [
    // tslint:disable-next-line:max-line-length
    'body .ui-accordion .ui-accordion-header:not(.ui-state-disabled).ui-state-active a { background-color: #f4f4f4 !important; border: 1px solid #c8c8c8 !important; color: #333333 !important; }',
    'body .ui-accordion .ui-accordion-header:not(.ui-state-disabled).ui-state-active a .ui-accordion-toggle-icon { color: #333333; }',
    'body .ui-accordion .ui-accordion-header { margin-bottom: -1px; }',
  ],
  providers: [DialogService],
})
export class DossierActionsListComponent
  extends BaseComponent
  implements AfterContentInit, OnInit, OnDestroy {
  loaded = false;
  loading = false;
  @Input()
  dossierId: string;
  @Input()
  divisionId: string;

  // para apertura modal
  windowHash: string;

  COLUMN_COUNT = 6;
  // @Input()
  // showAudit = true;
  // parameters: any = {
  selectedDivision: DivisionDTO;
  // }
  @Input()
  showMandatoryRules = true;
  @Input()
  showOptionalRules = true;
  @Input()
  showRunnigRules = false;
  @Input()
  showTasks = true;

  // ARBOL DE DIVISIONES
  rootNode: DivisionDTO;

  // reglas
  rules: RuleDTO[];
  userTasks: TaskDTO[];
  dossierTasks: TaskDTO[];
  visibleDossierTasks: TaskDTO[];
  //  auditList: Array<any>;
  users = new Map<string, UserDTO>();

  evaluationError: string;
  error: any;

  mandatoryActions: Array<any> = [];
  otherActions: Array<any> = [];
  public groupMandatoryActions = [];
  public groupOtherActions = [];

  stateGrouping = true;
  public actionNumberVisible: boolean;

  // INFORMACION DE LA PANTALLA ALMACENADA EN SESION
  userPrefs: UserPrefs;

  groupVisibility: ElementsVisibilityState;

  helpLabels: Array<string> = [];

  multiSignatureAvailable = true;

  project: any;

  // Para la rueda de acciones
  showActionButton = [];
  commandActionButton = {};
  openItemExist = [];
  tagsParent: string[];

  constructor(
    public plycaService: PlycaDataService,
    public taskService: TaskService,
    public ruleService: RuleService,
    public userService: UserService,
    public dossierService: DossierService,
    public uiService: UIService,
    private store: Store<AppState>,
    public helpService: HelpService,
    // public route: ActivatedRoute,
    public router: Router,
    public dialogService: DialogService,
    public configuration: Configuration,
    private headerActionsService: HeaderActionsService,
    private waitService: WaitLoadingService,
    public translate: TranslateService,
    public profileService: ProfileService,
    private plycaErrorHandler: PlycaErrorHandler,
    protected appConfig: AppConfiguration,
    protected translateService: TranslateService,
    private _http: HttpClient,
    private userPrefsService: UserPrefsService,
    @Optional() public ref: DynamicDialogRef,
    @Optional() public dialogConfig: DynamicDialogConfig
  ) {
    super();
    this.subscribe(this.userPrefsService.getUserPrefs(), (prefs: UserPrefs) => {
      this.userPrefs = prefs;
      if (!this.userPrefs.tasksViewPrefs) {
        this.userPrefs.tasksViewPrefs = new TasksViewPrefs();
      }
    });
    this.subscribe(
      this.store.select('elemVisibilityState'),
      (visibility: ElementsVisibilityState) => {
        if (!visibility) {
          this.groupVisibility = new ElementsVisibilityState();
        } else {
          this.groupVisibility = visibility;
        }

        if (!this.groupVisibility.panels) {
          this.groupVisibility.panels = new Array<ElementVisibilityStateDTO>();
        }
      }
    );
    // route.params.subscribe(params => {
    //   this.dossierId = params['id'];
    // });
    if (this.isAperturaModal()) {
      this.dossierId = dialogConfig['dossierId'];
      this.divisionId = dialogConfig['divisionId'];
      if (dialogConfig['showTasks'] !== undefined) {
        this.showTasks = dialogConfig['showTasks'];
      }
    }

    // // Activar suscripcion al store de tareas pendientes
    this.subscribe(
      this.store.select('pendingTasks'),
      (tasks: Array<TaskDTO>) => {
        this.userTasks = tasks;

        // Comprobamos si esta cargado rootnode por si en el arranque del componente
        // el subscribe salta antes de que se hayan leido las divisiones
        if (this.rootNode) {
          if (tasks && tasks.length) {
            this.dossierTasks = this.filterTaskByDossier(tasks);
            console.log(
              'invocando mixMandatoryRulesAndTasks desde la actualización de tareas'
            );
            this.mixMandatoryRulesAndTasks();
          }
        }
      }
    );
    this.addHelpLabel(HelpType.DOSSIER_ACTIONS);
    this.stateGrouping = this.appConfig.getValue('actionList.stateGrouping');
    this.actionNumberVisible = this.appConfig.getValue('actionList.actionNumber.visible');
  }

  ngOnInit() {
    this.subscribe(
      this.plycaService.getDossier(this.dossierId).pipe(
        tap((param) => {
          this.project = param;
          this.load();
          this.subscribe(interval(10000), () => {
            this.getServerLastEvalTime();
          });
        }),
        catchError((error: any) => {
          console.log(error);
          this.showErrorMessage(error);
          return throwError(error);
        })
      )
    );
    if (this.isAperturaModal()) {
      this.subscribe(this.helpService.getStoreTagsObservable().pipe(
        switchMap(
          (storedHelpTags) => {
            this.tagsParent = storedHelpTags;
            return this.helpService.showContextHelpObservable(HelpType.ACTIONS_LIST)
          }
        )));
    }
  }

  ngAfterContentInit(): void {
    if (this.isAperturaModal()) {
      let multiSignatureEnabled = this.appConfig.getValue(
        'multiSignatureEnabled'
      );
      this.windowHash = generateRandomIdentifier();
      this.headerActionsService.clearWindowActions(this.windowHash);
      this.subscribe(
        this.headerActionsService.addWindowAction(
          'General.reload',
          'fas fa-lg fa-sync-alt',
          'btn-primary',
          function () {
            return !this.isLoading();
          }.bind(this),
          this.windowHash
        ),
        () => {
          this.error = null;
          this.load();
        }
      );
      if (multiSignatureEnabled) {
        this.subscribe(
          this.headerActionsService.addWindowAction(
            'MultiSignature.action',
            'fas fa-lg fa-pen-nib',
            'btn-secondary',
            this.multiSignatureAvailable,
            this.windowHash
          ),
          () => {
            this.openMultiSignatureComponent();
          }
        );
      }
      this.headerActionsService.addDivider();
      this.subscribe(
        this.headerActionsService.addWindowAction(
          'General.close',
          'fas fa-close',
          'btn-outline-secondary',
          true,
          this.windowHash
        ),
        () => {
          this.ref.close();
        }
      );
    }
  }

  storeState(event, open: boolean, groups: Array<any>) {
    if (
      groups &&
      groups[event.index].division.identifier &&
      groups[event.index].division
    ) {
      let groupState: ElementVisibilityStateDTO =
        this.groupVisibility.panels.find(
          (g: ElementVisibilityStateDTO) =>
            g.type == ACTION_DIVISION_GROUP &&
            g.elementId == groups[event.index].division.identifier
        );
      if (!groupState) {
        groupState = new ElementVisibilityStateDTO();
        groupState.type = ACTION_DIVISION_GROUP;
        groupState.elementId = groups[event.index].division.identifier;
        this.groupVisibility.panels.push(groupState);
      }
      let index = this.groupVisibility.panels.indexOf(groupState);
      this.groupVisibility.panels[index].opened = open;
    }
  }

  ngOnDestroy(): void {
    let thisGroupVisibility = this.groupVisibility;
    if (this.isAperturaModal()) {
      this.headerActionsService.clearWindowActions(this.windowHash);
      this.subscribe(this.helpService.showContextHelpObservable(this.tagsParent).pipe(
        finalize(() => {
          super.ngOnDestroy();
        })));
    }

    this.dialogConfig = null;
    this.ref = null;
    this.store.dispatch(
      SET_ELEMVISIBILITY({ visibilityState: thisGroupVisibility })
    );
    super.ngOnDestroy();
  }

  isShowMandatoryRules() {
    return this.showMandatoryRules;
  }

  isShowOptionalRules() {
    return this.showOptionalRules;
  }
  // isShowAudit() {
  //   return this.showAudit;
  // }

  isAperturaModal(): boolean {
    return this.dialogConfig !== undefined && this.dialogConfig['dossierId'];
  }

  load(foreground = true) {
    if (this.loading) {
      return;
    }

    this.loaded = !foreground;
    this.loading = true;
    this.evaluationError = null;
    if (foreground) {
      this.waitService.startWaiting();
    }
    // Actualizar REGLAS y TAREAS
    this.subscribe(
      this.dossierService.getDivisionsTree(this.dossierId).pipe(
        tap((result) => {
          this.rootNode = result;
        })
      ),
      () => {
        // incluir retardo para que las tareas lleguen inmediatamente
        let delay = this.appConfig.getValue('task.delay.afterDispatch');
        if (!delay) {
          delay = 0;
        }
        let showTerminatedRules = false;

        if (
          this.project &&
          getSimpleIdentifierFromString(
            this.project?.modoTramitacion?.identifier
          ) === MANUALPROCESSINGMODE_ID
        ) {
          showTerminatedRules = true;
        }

        this.subscribe(
          timer(delay).pipe(
            switchMap(() =>
              this.taskService
                .consultaTareasObservable(this.dossierId)
                // of(undefined)
                .pipe(
                  tap((result) => {
                    if (result && result['content']) {
                      this.dossierTasks = result['content'];
                    } else {
                      this.dossierTasks = [];
                    }

                    this.dossierTasks = this.filterTaskByDossier(
                      this.dossierTasks
                    );
                  }),
                  concatMap(() =>
                    this.plycaService
                      .getDossierRules(
                        this.dossierId,
                        this.divisionId,
                        this.showRunnigRules,
                        showTerminatedRules
                      )
                      .pipe(
                        tap((result) => {
                          if (result && result.content) {
                            console.log('REGLAS RECUPERADAS: ', result.content);
                            // FILTRAR REGLAS QUE NO SE PUEDAN PROCESAR EN EL CLIENTE WEB
                            this.rules = result.content.filter(
                              (rule) =>
                                RuleOpeningModeTypeDTO.appletOnly !==
                                rule.openingMode
                            );
                            // extraer etiquetas de ayuda de las reglas y última hora de evaluación
                            this.rules.forEach((r) => {
                              this.addHelpLabelFromAction(r);
                            });
                          } else {
                            this.rules = [];
                          }
                        })
                      )
                  )
                )
            ),
            catchError((error: any) => {
              console.log(error);
              if (!this.error) {
                this.error = error;
                this.showErrorMessage(error);
              }
              return throwError(error);
            }),
            finalize(() => {
              forkJoin([
                this.mixMandatoryRulesAndTasks(),
                this.processOptionalRules(),
              ])
                .pipe(
                  finalize(() => {
                    this.waitService.cancelWaiting();
                  })
                )
                .subscribe(() => {
                  //this.loadHelp();
                  this.loaded = true;
                  this.loading = false;
                });
            })
          )
        );
      }
    );
  }

  // loadMenuItems() {
  //   // calcular las acciones de cada regla / tarea
  //   this.rules.forEach(r => {
  //     r['icon'] = this.getIcon(r);
  //     // r['menuItems'] = this.getActionMenuItems(r);
  //   });
  //   this.dossierTasks.forEach(task => {
  //     task['icon'] = this.getIcon(task);
  //     // task['menuItems'] = this.getActionMenuItems(task);
  //   });
  // }

  filterTaskByDossier(tasks: Array<TaskDTO>) {
    if (tasks) {
      if (this.divisionId != undefined) {
        return tasks.filter(
          (task) =>
            task.division.project.identifier === this.dossierId &&
            getSimpleIdentifierFromString(task.division.identifier) ===
            this.divisionId
        );
      } else {
        return tasks.filter(
          (task) => task.division.project.identifier === this.dossierId
        );
      }
    } else {
      return [];
    }
  }

  public isLoaded() {
    return this.loaded;
  }

  public isLoading() {
    return this.loading;
  }

  mixRulesAndTasks() {
    let _tmpDossierTasks = this.dossierTasks;
    if (!_tmpDossierTasks) {
      _tmpDossierTasks = [];
    }
    let _visibleDossierTasks = [..._tmpDossierTasks];
    if (this.showRunnigRules) {
      this.rules.forEach((rule: RuleDTO) => {
        if (
          this.isExecutable(rule) ||
          this.isRuleRunnig(rule) ||
          this.isRuleFinished(rule)
        ) {
          let procedure = rule?.executionStatus?.procedure;
          if (this.showTasks && procedure && _tmpDossierTasks) {
            // identificar las tareas asociadas a la jerarquia de tramites relacionada con la regla
            rule.relatedTasks = _visibleDossierTasks.filter((task: TaskDTO) => {
              if (task.procedure) {
                return this.isTaskInProcedure(task, procedure);
              } else {
                return false;
              }
            });
            // eliminamos del listado de tareas las que van a aparecer colgando de una regla
            _visibleDossierTasks = _visibleDossierTasks.filter(
              (task: TaskDTO) =>
                !rule.relatedTasks.find(
                  (_task) => _task.identifier === task.identifier
                )
            );
          }
        }
      });
    }
    this.visibleDossierTasks = [..._visibleDossierTasks];
  }

  isTaskInProcedure(task: TaskDTO, procedure: ProcedureDTO) {
    let ancesters = task?.procedure?.ancesters;
    let procIdentifiers: Array<string>;
    // if (task?.procedure?.ancesters) {
    // ancesters = "23<>32<>25";
    if (ancesters != undefined) {
      // procIdentifiers = task.procedure.ancesters.split('<>');
      procIdentifiers = ancesters.split('<>');
    } else {
      procIdentifiers = [getSimpleIdentifierFromString(procedure.identifier)];
    }
    console.log(
      'buscando',
      task.procedure.identifier,
      getSimpleIdentifierFromString(task?.procedure?.identifier),
      ' en ',
      procIdentifiers
    );
    let finded = procIdentifiers.find(
      (_id) =>
        getSimpleIdentifierFromString(task?.procedure?.identifier) === _id
    );
    // task.procedure?.identifier == procedure.identifier
    return finded;
  }

  mixMandatoryRulesAndTasks(): Observable<any> {
    let mandatoryRules;
    if (this.rules) {
      mandatoryRules = this.ruleService.filterRulesBySeverity(this.rules, [
        RuleSeverities.MANDATORY,
        RuleSeverities.RECOMMENDATION,
      ]);

      if (this.showRunnigRules) {
        // colgar las tareas de las reglas
        this.mixRulesAndTasks();

        // mostramos en la zona de obligatorias las acciones opcionales en ejecución
        let _optionalRules = this.ruleService.filterRulesBySeverity(
          this.rules,
          RuleSeverities.OPTIONAL
        );
        mandatoryRules.push(
          ..._optionalRules.filter((rule) => this.isRuleRunnig(rule))
        );

        // filtrar para que salgan solamente reglas ejecutables
        // mandatoryRules = mandatoryRules.filter(rule => (this.isExecutable(rule)
        // || this.isRuleRunnig(rule) || this.isRuleFinished(rule)));
      } else {
        this.visibleDossierTasks = [...this.dossierTasks];
        // filtrar para que salgan solamente reglas ejecutables
        mandatoryRules = mandatoryRules.filter((rule) =>
          this.isExecutable(rule)
        );
      }
    }
    // console.log('ACTUALIZANDO ACCIONES: ', this.dossierTasks, this.rules);
    this.mandatoryActions.length = 0;

    if (this.visibleDossierTasks && this.showTasks) {
      this.mandatoryActions.push(...this.visibleDossierTasks);
    }
    if (mandatoryRules) {
      this.mandatoryActions.push(...mandatoryRules);
    }

    this.mandatoryActions = this.sortActions(this.mandatoryActions);
    this.groupMandatoryActions = this.updateRowGroupMetaData(
      this.mandatoryActions,
      this.groupVisibility
    );
    console.log('ACTUALIZADOS ACCIONES DEL EXPEDIENTE', this.mandatoryActions);
    return of(true);
  }

  processOptionalRules(): Observable<any> {
    if (this.rules) {
      let _optionalRules = this.ruleService.filterRulesBySeverity(
        this.rules,
        RuleSeverities.OPTIONAL
      );

      // modo para que no aparezcan las que estan en ejecución como opcioales
      _optionalRules = _optionalRules.filter((rule) => this.isExecutable(rule));
      // modo antiguo
      // if (this.showRunnigRules) {
      //   // filtrar para que salgan también las que están en ejecución
      //   _optionalRules = _optionalRules.filter(rule => this.isExecutable(rule) || this.isRuleRunnig(rule));
      // } else {
      //   // filtrar para que salgan solamente reglas ejecutables
      //   _optionalRules = _optionalRules.filter(rule => this.isExecutable(rule));
      // }

      _optionalRules = this.sortActions(_optionalRules);
      this.groupOtherActions = this.updateRowGroupMetaData(
        _optionalRules,
        this.groupVisibility
      );
      this.otherActions = _optionalRules;
    }
    return of(true);
  }

  sortActions(actions: Array<any>) {
    if (actions) {
      return actions.sort((ac1, ac2) => {
        if (ac1.division.identifier === ac2.division.identifier) {
          if (this.showRunnigRules && this.stateGrouping) {
            if (ac1.state !== ac2.state) {
              return this.getStateAsNumber(ac1.state) <
                this.getStateAsNumber(ac2.state)
                ? -1
                : 1;
            }
          }

          // Si los pesos son diferentes ya modifican el orden
          if (this.getActionWeight(ac1) !== this.getActionWeight(ac2)) {
            return this.getActionWeight(ac1) < this.getActionWeight(ac2)
              ? -1
              : 1;
          }

          if (this.getActionGroup(ac1) === this.getActionGroup(ac2)) {
            if (ac1.name === ac2.name) {
              return ac1.instance < ac2.instance ? -1 : 1;
            } else {
              return ac1.name < ac2.name ? -1 : 1;
            }
          } else {
            let grp1 = this.getActionGroup(ac1) || '';
            let grp2 = this.getActionGroup(ac2) || '';

            return grp1.localeCompare(grp2);
            // if (grp1 == undefined) {
            //   return -1;
            // } else if (grp2 == undefined) {
            //   return 1
            // } else {
            //   return grp1.localeCompare(grp2);
            // }
          }
        }
        return this.compareDivisions(ac1.division, ac2.division);
      });
    }
  }

  compareDivisions(div1: DivisionDTO, div2: DivisionDTO) {
    let id1 = +getSimpleIdentifierFromString(div1.identifier);
    let id2 = +getSimpleIdentifierFromString(div2.identifier);
    return id1 < id2 ? -1 : 1;
  }

  getActionWeight(act): string {
    if (act && act.parameters) {
      // let grp = act['GROUP'];
      let weight = undefined;
      let weightParam = act.parameters.find((param) => param.name === 'PESO');
      if (weightParam) {
        weight = +weightParam.value;
      }
      if (weight == undefined) {
        weight = 0;
      }
      return weight;
    } else {
      return undefined;
    }
  }

  getActionGroup(act): string {
    if (act && act.parameters) {
      // let grp = act['GROUP'];
      let grp = undefined;
      let grpParam = act.parameters.find((param) => param.name === 'GROUP');
      if (grpParam) {
        grp = grpParam.value;
      }
      if (grp == undefined) {
        grp = '';
      }
      return grp;
    } else {
      return undefined;
    }
  }

  getActionGroupText(act): string {
    let enabled = false;
    if (enabled) {
      return this.getActionGroup(act) + ' - ';
    }
    return '';
  }

  calculateDeepMargin(act) {
    return this.calculateDeep(act) * 15;
  }

  calculateDeep(act) {
    let grp = this.getActionGroup(act);
    if (grp == undefined || '' == grp) {
      return 0;
    } else {
      let deep = grp.split(';').length;
      if ('GROUPING_RULE' === act.type) {
        deep--;
      }
      return deep;
    }
  }

  updateRowGroupMetaData(
    actions: Array<any>,
    groupVisibility: ElementsVisibilityState
  ) {
    let _actionsGroup = [];
    if (actions) {
      // anadir expediente y contratos
      _actionsGroup.push({
        division: this.rootNode,
        rules: [],
        count: 0,
        groups: [],
      });
      if (this.rootNode.children) {
        this.rootNode.children.forEach((div) => {
          // AGRUPAMOS LAS DIVISINES DE PRIMER NIVEL QUE SEAN CONTRATOS
          if (div.documentClass.identifier == '02001') {
            _actionsGroup.push({
              division: div,
              rules: [],
              count: 0,
              groups: [],
            });
          }
        });
      }

      for (let i = 0; i < actions.length; i++) {
        let currentAction = actions[i];

        let divisionGroup = _actionsGroup.find(
          (group) =>
            group.division.identifier === currentAction.division.identifier
        );
        if (!divisionGroup) {
          let parentDivisionGroup = _actionsGroup.find((group) => {
            if (currentAction.division.parent) {
              return (
                group.division.identifier ===
                currentAction.division.parent.identifier
              );
            } else {
              return false;
            }
          });
          if (parentDivisionGroup) {
            divisionGroup = parentDivisionGroup['groups'].find(
              (group) =>
                group.division.identifier === currentAction.division.identifier
            );
            if (!divisionGroup) {
              // Vemos si ya ha sido marcado para verse abierto o cerrado
              let groupState: ElementVisibilityStateDTO =
                groupVisibility.panels.find(
                  (g: ElementVisibilityStateDTO) =>
                    g.type == ACTION_DIVISION_GROUP &&
                    g.elementId == currentAction.division.identifier
                );
              let opened: boolean = false;
              if (groupState) {
                opened = groupState.opened;
              } else {
                // LAS INCIDENCIAS APARECEN DESPLEGADAS POR DEFECTO
                opened =
                  currentAction.division.documentClass.identifier === '02004';
              }
              console.log(
                'DIVISION ABIERTA? ',
                currentAction.division.documentClass.identifier,
                opened
              );
              divisionGroup = {
                division: currentAction.division,
                rules: [],
                opened: opened,
              };
              parentDivisionGroup['groups'].push(divisionGroup);
            }
            parentDivisionGroup['count']++;
          }
        } else {
          divisionGroup['count']++;
        }

        if (divisionGroup) {
          divisionGroup.rules.push(currentAction);
        }
      }

      // _actionsGroup[0].rules = this.createGroupRules(_actionsGroup[0].rules);
      _actionsGroup.forEach((_actionGroup) => {
        _actionGroup.rules = this.createGroupRules(_actionGroup.rules);
        if (_actionGroup.groups) {
          _actionGroup.groups.forEach((_actionGroup2) => {
            _actionGroup2.rules = this.createGroupRules(_actionGroup2.rules);
          });
        }
      });


      if (this.showRunnigRules) {
        _actionsGroup.forEach((_actionGroup) => {
          _actionGroup.actionsListGroupMetadata = this.updateRowGroupMetaData2(
            _actionGroup.rules
          );
          if (_actionGroup.groups) {
            _actionGroup.groups.forEach((internalGrp) => {
              internalGrp.actionsListGroupMetadata =
                this.updateRowGroupMetaData2(internalGrp.rules);
            });
          }
        });
      }
      // ELIMINAR GRUPOS VACIOS
      _actionsGroup = _actionsGroup.filter(
        (grp) => (grp.groups && grp.groups.length > 0) || grp.count > 0
      );
    }
    return _actionsGroup;
  }

  createGroupRules(rules: Array<any>) {
    let newRules = [];
    let createdGroups = [];
    console.log('reglas', rules);
    rules.forEach((rule, idx) => {
      let ruleGrp = this.getActionGroup(rule);
      if (ruleGrp) {
        let groupPath = ruleGrp.split(';');
        let parentPath = '';
        groupPath.forEach((grpPathI) => {
          let grpI = parentPath === '' ? grpPathI : parentPath + ';' + grpPathI;
          console.log('BUSCANDO GRUPO', ruleGrp, createdGroups.includes(grpI));
          if (grpI && !createdGroups.includes(grpI)) {
            createdGroups.push(grpI);
            // let newRule = this.createRuleGroup(rule);
            // rules.splice(idx, 0, newRule);
            newRules.push(this.createRuleGroup(rule, grpI));
          }
          parentPath = grpI;
        });
      }
      newRules.push(rule);
    });
    console.log('reglas agrupadas', rules);
    return newRules;
  }

  createRuleGroup(rule, groupName): RuleDTO {
    let ruleGroup = new RuleDTO();
    ruleGroup.type = 'GROUPING_RULE';
    ruleGroup.division = rule.division;
    ruleGroup.severity = RuleSeverities.MANDATORY;
    ruleGroup.identifier = groupName;
    ruleGroup.name = groupName;
    // ruleGroup['GROUP'] = groupName;
    ruleGroup.parameters = [];
    let grpParam = new RuleParameters();
    grpParam.name = 'GROUP';
    grpParam.value = groupName;
    ruleGroup.parameters.push(grpParam);
    // ruleGroup.deep = this.calculateDeep(ruleGroup);
    ruleGroup.description = groupName.split(';')[this.calculateDeep(ruleGroup)];
    return ruleGroup;
  }

  isRuleDTO(dossierAction: any): boolean {
    return dossierAction.severity !== undefined;
  }

  isLocked(dossierAction: any) {
    if (this.isRuleDTO(dossierAction)) {
      return dossierAction.locked;
    } else {
      let task: TaskDTO = <TaskDTO>dossierAction;
      return task.status === 'LOCKED' && task.lockedBy;
    }
  }

  isGroupingRule(dossierAction: any) {
    if (this.isRuleDTO(dossierAction)) {
      let rule: RuleDTO = <RuleDTO>dossierAction;
      return 'GROUPING_RULE' === rule?.type;
    }
    return false;
  }

  isCancelRuleAvailable(dossierAction: any): boolean {
    if (
      this.isRuleDTO(dossierAction) &&
      dossierAction.availableActions &&
      dossierAction.availableActions.actions
    ) {
      let availableActions: Array<ActionDTO> =
        dossierAction.availableActions.actions;
      let url: string;
      let description;
      for (let action of availableActions) {
        if (action.identifier === ActionTypeDTO.RULE_CANCEL) {
          let links: Link[];
          links = action.links;
          url = links[0].href;
          description = action.description;
          // dossierAction.availableActions.actions[]
          break;
        }
      }

      return url ? true : false;
    } else {
      return false;
    }
  }

  getCancelDescription(dossierAction: any): string {
    let availableActions: Array<ActionDTO> =
      dossierAction.availableActions.actions;
    let url: string;
    let description;
    for (let action of availableActions) {
      if (action.identifier === ActionTypeDTO.RULE_CANCEL) {
        let links: Link[];
        links = action.links;
        url = links[0].href;
        description = action.name;
        // dossierAction.availableActions.actions[]
        break;
      }
    }
    return description;
  }

  cancelRule(rule: any) {
    this.waitService.startWaiting();
    let availableActions: Array<ActionDTO> = rule.availableActions.actions;
    let url: string;
    let actionCANCELRULE;
    for (let action of availableActions) {
      if (action.identifier === ActionTypeDTO.RULE_CANCEL) {
        let links: Link[];
        links = action.links;
        url = links[0].href;
        actionCANCELRULE = action;
        break;
      }
    }
    if (url) {
      this.subscribe(this.openActionModal(actionCANCELRULE).onClose, () => {
        this.load();
      });
    }
  }
  openActionModal(action: ActionDTO) {
    let config: DynamicDialogConfig = {
      header: action.name,
      width: '70%',
      styleClass: 'actionStyle',
    };
    config['action'] = action;
    config['dto'] = action.target;

    return this.dialogService.open(ActionsProcessComponent, config);
  }
  getIcon(dossierAction: any): string {
    let styleClass = '';
    if (this.isRuleDTO(dossierAction)) {
      if (
        !dossierAction.relatedTasks ||
        dossierAction.relatedTasks.length === 0
      ) {
        styleClass = this.ruleService.getRuleIcon(dossierAction);
      }
      if (this.isLocked(dossierAction)) {
        styleClass = ' fa fa-lock text-danger ';
      }
    } else {
      styleClass = this.taskService.getTaskIcon(dossierAction);
    }

    return styleClass;
  }
  
  getStyle(dossierAction: any) {
	    if (this.isRuleDTO(dossierAction)) {
	      let mandatory = this.ruleService.isMandatoryDocument(dossierAction);
	      if (mandatory)
	        return 'color:#ffc107';
	      else
	        return 'color:#000000';

	    } else
	      return '';
	  }

  getTooltip(dossierAction: any) {
	    let mandatory = this.ruleService.isMandatoryDocument(dossierAction);
	    let description = this.getDescription(dossierAction);
	    let prefix = mandatory ? '(' + this.translate.instant('Envelope.edit.required') + ') ' : '';
	    return prefix + description;
  }

  
  getLockedBy(dossierAction: any) {
    if (
      dossierAction['lockedBy'] &&
      dossierAction['lockedBy'].identifier &&
      !dossierAction['lockedBy'].person
    ) {
      if (this.users.get(dossierAction['lockedBy'].identifier) != null) {
        dossierAction['lockedBy'] = this.users.get(
          dossierAction['lockedBy'].identifier
        );
        return dossierAction['lockedBy'];
      } else {
        this.subscribe(
          this.plycaService.getUser(dossierAction['lockedBy']),
          (user) => {
            this.users.set(dossierAction['lockedBy'].identifier, user);
            dossierAction['lockedBy'] = user;
            return dossierAction['lockedBy'];
          },
          (error) => {
            console.log(error);
            return undefined;
          }
        );
      }
    } else {
      return dossierAction['lockedBy'];
    }
  }

  getDescription(dossierAction: any) {
    return dossierAction['description'];
  }

  showActionProfiles(dossierAction?: any) {
    return (
      this.userPrefs &&
      this.userPrefs.tasksViewPrefs &&
      this.userPrefs.tasksViewPrefs.showProfile &&
      (dossierAction == undefined ||
        (dossierAction != undefined &&
          ((dossierAction.profile && dossierAction.profile.identifier) ||
            (dossierAction.parameters &&
              dossierAction.parameters.find(
                (param) => param.name === 'PERFIL'
              )))))
    );
  }

  getProfiles(dossierAction: any): string {
    let profiles: string[] = [];
    if (dossierAction.profile && dossierAction.profile.identifier) {
      profiles.push(dossierAction.profile.identifier);
    }
    if (dossierAction.profiles) {
      dossierAction.profiles.forEach((element) => {
        profiles.push(element.identifier);
      });
    } else {
      if (dossierAction.parameters) {
        let paramProfile = dossierAction.parameters.find(
          (param) => param.name === 'PERFIL'
        );
        if (paramProfile && paramProfile.value) {
          profiles = profiles.concat(
            paramProfile.value.replaceAll(';', ',').split(',')
          );
        }
      }
    }
    if (!profiles || profiles.length == 0) {
      return '';
    }
    profiles = profiles.map((id) => {
      //Quitamos la T de tramitador
      const cleanId = (''+id).replace(/[^0-9]/g, '');
      return this.profileService.getProfile(+cleanId).description;
    });
    return profiles.join(' , ');
  }
  isAuditable(dossierAction: any) {
    if (this.isRuleDTO(dossierAction)) {
      return this.ruleService.isProcedureAuditable(dossierAction);
    } else {
      return true;
    }
  }

  isExecutable(dossierAction: any) {
    if (this.isRuleDTO(dossierAction)) {
      return this.ruleService.isRuleExecutable(dossierAction);
    } else {
      return true;
      // return !this.isLocked(dossierAction); --> Incluir esta validacion aqui?
    }
  }

  isRuleRunnig(rule: RuleDTO): boolean {
    let ret: boolean;
    ret = rule.type === RuleTypes.PROCEDURE;
    ret = ret && rule.state === RuleStates.PROCESSING;
    return ret;
  }

  isRuleFinished(rule: RuleDTO) {
    let ret: boolean;
    ret = rule.type === RuleTypes.PROCEDURE;
    ret = ret && rule.state === RuleStates.COMPLETED;
    return ret;
  }

  isExecutableAndNotLocked(dossierAction: any) {
    return this.isExecutable(dossierAction) && !this.isLocked(dossierAction);
  }

  isNecessary(dossierAction: any) {
    let isRule = this.isRuleDTO(dossierAction);
    return (
      // !isRule ||
      isRule &&
      dossierAction.state !== 'completed' &&
      (dossierAction['severity'] === RuleSeverities.MANDATORY ||
        (dossierAction.type === 'task' &&
          (RuleWorkStates.IN_PROGRESS === dossierAction.task.work.state ||
            RuleWorkStates.COMPLETED === dossierAction.task.work.state)))
    );
  }

  // COMPRUEBA SI LA REGLA ES EJECUTABLE Y DE TIPO PROCEDURE
  isProcedureExecutable(rule: RuleDTO): boolean {
    return this.ruleService.isProcedureExecutable(rule);
  }

  isProcedureExecutableAndNotLocked(rule: RuleDTO): boolean {
    return this.ruleService.isProcedureExecutable(rule) && !rule.locked;
  }

  execute(dossierAction: any) {
    console.log('EXECUTING ACTION');
    if (this.isExecutableAndNotLocked(dossierAction)) {
      if (this.isRuleDTO(dossierAction)) {

        // Si es una regla de tipo server, pedir confirmacion al usuario
        // if (dossierAction.type === RuleTypes.SERVER) {
        if (dossierAction.type !== RuleTypes.TASK) {
          let msg = this.translate.instant('Actions.exec.confirmation');
          if (dossierAction.parameters) {
            dossierAction.parameters.forEach((p) => {
              if (p.name === 'ACTION_CONFIRM_MESSAGE') {
                msg = p.value;
              }
            })
          }
          this.uiService.showConfirmMessage({
            message: msg,
            header: this.translate.instant('General.confirmtext'),
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
              this.executeRule(dossierAction);
            },
            reject: () => {
              //
            },
          });
        } else if (
          dossierAction.type == RuleTypes.TASK &&
          dossierAction.parameters.find((x) => x.name == 'ENLACE_URL')
        ) {
          // Si es un mensaje de apertura de una URL
          let url = dossierAction.parameters.find(
            (x) => x.name == 'ENLACE_URL'
          ).value;
          let target = '_blank';
          if (dossierAction.parameters.find((x) => x.name == 'ENLACE_TARGET')) {
            target = dossierAction.parameters.find(
              (x) => x.name == 'ENLACE_TARGET'
            ).value;
          }
          window.open(url, target);
        } else {
          this.executeRule(dossierAction);
        }
      } else {
        this.taskService.openTask(dossierAction);
        if (this.isAperturaModal()) {
          this.ref.close();
        }
      }
    }
  }

  private executeRule(dossierAction: RuleDTO) {
	    this.waitService.startWaiting();
	    let execResult = this.ruleService.executeRule(dossierAction);
	    // si la regla no es de tipo task devuelve un observable
	    if (execResult) {
	      this.subscribe(execResult,
	        () => {
	          if (this.isAperturaModal() && dossierAction.type !== RuleTypes.PROCEDURE) {
	            this.ref.close();
	          } else { // if (dossierAction.type !== RuleTypes.TASK) {
	            this.load();
	          }
	        },
	        (error) => {
	          console.log(error);
	          this.showErrorMessage(error);
	        }
	      );
	    }
	  }

  public _getSimpleIdentifierFromString(identifier) {
    return getSimpleIdentifierFromString(identifier);
  }

  addHelpLabelFromAction(dossierAction: any) {
    if (this.isRuleDTO(dossierAction)) {
      let rule: RuleDTO = dossierAction;
      if (rule.division['documentClass']) {
        this.addHelpLabel(
          'D_' +
          getSimpleIdentifierFromString(
            // rule.division.listadocId
            rule.division['documentClass'].abbreviation
          )
        );
      }
      if (rule.division.procedure) {
        this.addHelpLabel(
          'P_' +
          getSimpleIdentifierFromString(rule.division.procedure.identifier)
        );
      }
      if (rule.division.phase) {
        this.addHelpLabel(
          'F_' + getSimpleIdentifierFromString(rule.division.phase.identifier)
        );
      }
    } else {
    }
  }

  addHelpLabel(label: string) {
    if (this.helpLabels.indexOf(label) === -1) {
      this.helpLabels.push(label);
    }
  }

  loadHelp() {
    console.log('CARGANDO AYUDA', this.helpLabels.join(' '));
    if (this.helpLabels) {
      //      this.helpService.showContextHelp(this.helpLabels.join(' '));
      this.subscribe(
        this.helpService.showContextHelpObservable(this.helpLabels)
      );
    }
  }

  unLock(dossierAction: any) {
    if (this.isRuleDTO(dossierAction)) {
      this.unlockRule(dossierAction);
    } else {
      this.unlockTask(dossierAction);
    }
  }

  unlockRule(rule: RuleDTO): void {
    this.subscribe(
      this.ruleService.unlockRule(rule),
      () => {
        this.load();
      },
      (err: any) => {
        this.showErrorMessage(err);
      }
    );
  }

  unlockTask(task: any): void {
    this.waitService.startWaiting();
    this.subscribe(
      this.taskService.unlockTask(task).pipe(
        finalize(() => {
          this.waitService.cancelWaiting();
        })
      ),
      () => {
        this.load();
      },
      (err: any) => this.plycaErrorHandler.showServerError(err)
      //  this.uiService.showMessage(err, '', 'helpStyle')

      /*,
      (err: any) => this.showErrorMessage(err)*/
    );
  }

  showErrorMessage(err) {
    this.plycaErrorHandler.showServerError(err);
  }

  getServerLastEvalTime(): void {
    if (!this.error) {
      this.subscribe(
        this.plycaService.getDossierLastEvalTime(this.dossierId),
        (remoteLastEval) => {
          if (remoteLastEval && !this.loading) {
            this.load(false);
          }
        },
        (err) => {
          console.log(
            'Error consultando la fecha de última evaluación expediente'
          );
          console.log(err);
        }
      );
    }
  }

  openMultiSignatureComponent(): void {
    let config: DynamicDialogConfig = {
      header: this.translate.instant('MultiSignature.document.signature'),
      width: '75%',
      style: { overflow: 'hidden', 'max-height': '90%' },
      styleClass: 'formEdition',
      closeOnEscape: false,
      data: {
        dossierId: this.dossierId,
      },
    };
    let curentHelpTags = [];

    this.subscribe(
      this.helpService
        .getStoreTagsObservable()
        .pipe(switchMap((helpTags) => (curentHelpTags = helpTags)))
    );

    const dialog = this.dialogService.open(multiSignatureComponent, config);

    dialog.onClose.pipe(take(1)).subscribe(() => {
      this.subscribe(
        this.helpService.showContextHelpObservable(curentHelpTags)
      );
    });
  }

  showAudit(ruleDTO: RuleDTO) {
    let config: DynamicDialogConfig = {
      header: 'Mostrar auditoría',
      width: '70%',
      style: { overflow: 'hidden', 'max-height': '80%', 'min-height': '180px' },
    };
    let procedure: ProcedureDTO = ruleDTO.executionStatus.procedure;
    if (procedure) {
      config['id'] = this.dossierId;
      config['procedureId'] = getSimpleIdentifier(<any>procedure.identifier);
      this.dialogService.open(AuditComponent, config);
    }
  }

  showDocument(ruleDTO: RuleDTO) {
    // let doc: DocumentDTO;
    let doc: DocumentDTO = ruleDTO.executionStatus.document;
    let config: DynamicDialogConfig = {
      header: doc.name,
      width: '97%',
      styleClass: 'searchStyle',
    };

    config.data = {
      id: doc.identifier,
    };
    // this.waitService.startWaiting();
    let modal = this.dialogService.open(documentViewerComponent, config);
    this.subscribe(modal.onClose);
  }

  public getBuscadorDivisionTree(): FieldConfig {
    let config = new FieldConfig();
    config.type = 'DIVISION';
    config.jsonField = 'selectedDivision';
    config.description = '';
    config.fieldStyle = 'plForm-element';
    config.idBuscador = this.dossierId;
    return config;
  }

  changeDivision() {
    let _divisionId = getSimpleIdentifierFromString(
      this.selectedDivision.identifier
    );
    if (this.divisionId !== _divisionId) {
      this.divisionId = _divisionId;
      this.load();
    }
  }

  getActionMenuItems(dossierAction: any) {
    let items: MenuItem[] = [];
    this.openItemExist[dossierAction.identifier] = false;
    this.showActionButton[dossierAction.identifier] = true;
    if (
      !(this.isRuleDTO(dossierAction) && dossierAction.type === undefined) &&
      this.isExecutableAndNotLocked(dossierAction)
    ) {
      let mn = <MenuItem>{};
      mn.label = 'Abrir';
      mn.title = 'Abrir';
      mn.icon = 'fa fa-play';
      mn['dossierAction'] = dossierAction;
      mn.command = (event: Event) => {
        this.execute(mn['dossierAction']);
      };
      items.push(mn);
      this.openItemExist[dossierAction.identifier] = true;
    } else if (this.isLocked(dossierAction)) {
      let mn = <MenuItem>{};
      mn.label = 'Desbloquear';
      mn.title = 'Desbloquear';
      mn.icon = 'fa fa-unlock';
      mn['dossierAction'] = dossierAction;
      mn.command = (event: Event) => {
        this.unLock(mn['dossierAction']);
      };
      items.push(mn);
    }

    // mn.label = 'Desbloquear';
    // mn.title = 'Desbloquear';
    // mn.icon = 'fa fa-unlock';
    {
      let mn = <MenuItem>{};
      mn.separator = true;
      items.push(mn);
    }

    if (
      dossierAction.executionStatus &&
      dossierAction.executionStatus.procedure
    ) {
      let mn = <MenuItem>{};
      mn.label = 'Auditar';
      mn.title = 'Auditar';
      mn.icon = 'fas fa-list-ul';
      mn['dossierAction'] = dossierAction;
      mn.command = (event: Event) => {
        this.showAudit(mn['dossierAction']);
      };
      items.push(mn);
    }

    if (
      dossierAction.executionStatus &&
      dossierAction.executionStatus.document
    ) {
      let mn = <MenuItem>{};
      mn.label = 'Ver Documento';
      mn.title = 'Ver documento';
      mn.icon = 'fas fa-file-alt';
      mn['dossierAction'] = dossierAction;
      mn.command = (event: Event) => {
        this.showDocument(mn['dossierAction']);
      };
      items.push(mn);
    }

    if (this.isCancelRuleAvailable(dossierAction)) {
      let mn = <MenuItem>{};
      mn.label = 'Cancelar regla';
      mn.title = 'Cancelar regla';
      mn.icon = 'fa-ban fas';
      mn['dossierAction'] = dossierAction;
      mn.command = (event: Event) => {
        this.cancelRule(mn['dossierAction']);
      };
      items.push(mn);
    }
    if (items.length === 2 && items[1]?.separator === true) {
      items.pop();
    }
    // Accion abrir y separador
    if (items.length === 1) {
      this.showActionButton[dossierAction.identifier] = false;
      this.commandActionButton[dossierAction.identifier] = items[0];
    }
    return items;
  }
  public executeButtonCommand(event: Event, dossierActionId: string) {
    this.commandActionButton[dossierActionId].command.apply(this, event);
  }
  getStateAsNumber(state) {
    if (state == RuleStates.COMPLETED) {
      return 2;
    } else if (state == RuleStates.DISCARTED) {
      return 3;
    } else if (state == RuleStates.PENDING) {
      return 0;
    } else if (state == RuleStates.PROCESSING) {
      return 1;
    }
  }

  // tdclick(event) {
  //   event.stopPropagation()
  // };

  // _mandatoryRulesGroupMetadata: any = {};
  // _optionalRulesGroupMetadata: any = {};
  updateRowGroupMetaData2(dossierActions: Array<any>) {
    let rowGroupMetadata2 = {};
    let field = 'state';

    if (dossierActions) {
      for (let i = 0; i < dossierActions.length; i++) {
        let rowData = dossierActions[i];
        let fieldValue = rowData[field];

        if (i == 0) {
          rowGroupMetadata2[fieldValue] = { index: 0, size: 1 };
        } else {
          let previousRowData = dossierActions[i - 1];
          let previousRowGroup = previousRowData[field];
          if (fieldValue === previousRowGroup) {
            rowGroupMetadata2[fieldValue].size++;
          } else {
            rowGroupMetadata2[fieldValue] = { index: i, size: 1 };
          }
        }
      }
    }
    return rowGroupMetadata2;
  }

  getStateDescription(state) {
    let _state = {};
    switch (state) {
      case RuleStates.COMPLETED:
        _state['description'] = 'Completado';
        _state['icon'] = 'badge-success';
        break;
      case RuleStates.DISCARTED:
        _state['description'] = 'Descartado';
        _state['icon'] = 'badge-primary';
        break;
      case RuleStates.PENDING:
        _state['description'] = 'Pendiente';
        _state['icon'] = 'badge-secondary';
        break;
      case RuleStates.PROCESSING:
        _state['description'] = 'En proceso';
        _state['icon'] = 'badge-warning';
        break;
    }
    return _state;
  }

  showInbox(element: any) {
    let config: DynamicDialogConfig = {
      header:
        this.translate.instant('Audit.UsersTaskAccess.title') +
        ': (' +
        element.identifier +
        ') ' +
        element.name +
        '.',
      width: '60%',
      style: { 'max-height': '60%' },
      styleClass: 'helpStyle',
    };

    config['inboxId'] = element.identifier;
    config['inboxDescription'] = element.name
      ? element.name
      : element.identifier;
    const ref = this.dialogService.open(InboxUsersComponent, config);
    let curentHelpTags = [];
    this.subscribe(
      this.helpService
        .getStoreTagsObservable()
        .pipe(switchMap((helpTags) => (curentHelpTags = helpTags)))
    );
    this.subscribe(ref.onClose, () => {
      this.subscribe(
        this.helpService.showContextHelpObservable(curentHelpTags)
      );
    });
  }
}
